import { HttpResponse } from '@angular/common/http';
import { QuizQuestion } from './quiz-question';
import { QuizQuestionDto } from './quiz-question.dto';

export class PaginatedDto {
    readonly payload: QuizQuestion[];
    readonly total: number;

    constructor(response: HttpResponse<QuizQuestionDto[]>) {
        this.payload = (response.body ?? []).map((dto) => new QuizQuestion(dto));
        this.total = parseInt(response.headers.get('X-Total-Count') ?? '0', 10);
    }
}
